import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react'
import { action, observable, makeObservable } from 'mobx'
import { Helmet } from 'react-helmet'
import { pathOr } from 'ramda'
import { Formik, Form, Field } from 'formik'
import * as Yup from 'yup'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ReactRouterPropTypes from 'react-router-prop-types'
import Modal from 'react-responsive-modal'
import { store as notifications } from 'react-notifications-component'

import { html2jsx } from 'Lib/parser'
// import injectPlayerScript from 'Lib/injectPlayer'
import BaseLayout from 'Containers/Sites/Base/Layouts/base'
import { getBonusStatus, saveBonusData } from 'Api/endpoints/user'
import Spinner from 'Components/spinner'
import Masthead from '../../Components/masthead'

@inject('store')
@observer
class Bonus extends Component {
  static propTypes = {
    store: MobxPropTypes.objectOrObservableObject
  }

  @observable loading = true

  @observable allowed = false

  @observable previouslySubmitted = false

  @observable title = ''

  @observable showError = false

  @observable showThanks = false

  @observable modalIsOpen = false

  @observable modalContent = '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'

  componentDidMount () {
    // injectPlayerScript()

    this.trackPage()
  }

  constructor (props) {
    super(props)
    makeObservable(this)

    this.getBonusStatus()
  }

  @action.bound
  toggleModal () {
    this.modalIsOpen = !this.modalIsOpen
    // injectPlayerScript()
  }

  @action.bound
  async getBonusStatus () {
    const { publication } = this.props
    const { sitecode } = this.props.store.site
    const { bonus: name } = this.props.match.params

    if (!publication || !sitecode || !name) {
      return
    }

    const data = await getBonusStatus(sitecode, publication.code, name)

    this.loading = false
    this.allowed = data.status.toLowerCase() === 'allowed'
    this.title = pathOr('Bonus', ['button', 'title'])(data)
    this.previouslySubmitted = data.completed
  }

  @action.bound
  updateFieldValue (name, value) {
    this[name] = value
    this.showError = false
  }

  @action.bound
  updateRecaptchaValue (e) {
    this.recaptchaValue = e
  }

  @action.bound
  async handleSubmit (values) {
    const { publication } = this.props
    const { sitecode } = this.props.store.site
    const { bonus: name } = this.props.match.params
    const { address } = values

    const [{ status }] = await saveBonusData(sitecode, publication.code, name, address)

    if (status.toLowerCase() === 'ok') {
      this.showThanks = true
      notifications.addNotification({
        title: 'Success!',
        message: 'Your information has been successfully submitted! Thank you.',
        type: 'success',
        insert: 'top',
        container: 'top-center',
        animationIn: ['animated', 'fadeIn'],
        animationOut: ['animated', 'fadeOut'],
        dismiss: {
          duration: 5000,
          onScreen: true
        }
      })
    } else if (status.toLowerCase() === 'invalidkey') {
      notifications.addNotification({
        title: 'Error',
        message: 'The address provided does not appear to be a valid Solana one. Please check with your wallet aand retry.',
        type: 'danger',
        insert: 'top',
        container: 'top-center',
        animationIn: ['animated', 'fadeIn'],
        animationOut: ['animated', 'fadeOut'],
        dismiss: {
          duration: 20000,
          onScreen: true
        }
      })
    } else {
      window.alert('Something went wrong. Please try again.')
    }
  }

  @action.bound
  trackPage () {
    const { session } = this.props.store.user

    const sessionId = session ? session.id : null

    const obj = {
      session: sessionId,
      event: 'other',
      url: window.location.href,
      status: 1,
      scroll_depth: 100
    }

    this.props.store.user.analyticsAdd(obj)
  }

  render () {
    const { shouldContactMsg } = this.props.store.ui
    const {
      siteDetails,
      siteDetails: { messages: { contactMsg } }
    } = this.props.store.site

    if (this.loading) {
      return (
        <BaseLayout>
          <Masthead />

          <div className='container'>
            <div className='row'>
              <div className='col-12'>
                <Spinner />
              </div>
            </div>
          </div>
        </BaseLayout>
      )
    }

    if (!this.loading && !this.allowed) {
      return (
        <BaseLayout>
          <Masthead />
          <div className='container'>
            <div className='row'>
              <div className='col-12'>
                <h1>Content expired</h1>
                <p>This opportunity is not available any more.</p>
              </div>
            </div>
          </div>
        </BaseLayout>
      )
    }

    return (
      <BaseLayout>

        <Masthead />

        <div id='__page_bonus' className=''>
          <Helmet>
            <title>{this.title}</title>
          </Helmet>

          <div className='container'>
            <div className='row'>
              <div className='col-12'>
                <header className='headerWrapper'>
                  {shouldContactMsg && (
                    <aside className='contactMessage'>
                      <div className='alert alert-warning text-center'>
                        <p className='mb-0'>
                          {html2jsx(contactMsg.content)}
                        </p>
                      </div>
                    </aside>
                  )}
                  <h1>{this.title}</h1>
                </header>
              </div>
            </div>
          </div>

          <main className='container'>
            <div className='row preamble'>
              <div className='col-12'>
                <p>
                  To receive your free NFT from Brownstone Research, please complete the
                  below form. The Brownstone Research team will  be accepting address submissions through February 2, 2022.
                  NFTs will be distributed shortly after. Please ensure you have entered your information
                  before that date to receive your free NFT.
                </p>

                <p>
                  <button className='btn btn-secondary' onClick={() => this.toggleModal()}>View Instructions</button>
                </p>

                {this.previouslySubmitted && (
                  <h4>You have already successfully submitted your wallet address, but you may still update it.</h4>
                )}
              </div>
            </div>

            <div className='row'>
              <div className='col-lg-6 new-form-contact'>
                {!this.showThanks && (
                  <Formik
                    initialValues={{
                      address: '',
                      addressVerification: ''
                    }}
                    onSubmit={this.handleSubmit}
                    validationSchema={Yup.object({
                      address: Yup.string()
                        .required('Wallet address is required'),
                      addressVerification: Yup.string()
                        .required('Verification is required')
                        .oneOf([Yup.ref('address')], 'Addresses must match')
                    })}
                  >
                    {formProps => (
                      <Form>
                        <div className='row'>
                          <div className='col-12'>
                            <label htmlFor='subscription' className=''>Wallet Address *</label>
                          </div>

                          <div className='col-12'>
                            <Field name='address'>
                              {({
                                field,
                                meta
                              }) => (
                                <>
                                  <div className='fieldWrapper'>
                                    <input
                                      type='text'
                                      className='form-control'
                                      placeholder='' {...field}
                                      aria-required='true'
                                      aria-invalid={!!(meta.touched && meta.error)}
                                      aria-describedby={meta.error}
                                    />
                                  </div>
                                  {meta.touched && meta.error && (
                                    <div className='error'>{meta.error}</div>
                                  )}
                                </>
                              )}
                            </Field>
                          </div>

                          <div className='col-12'>
                            <label htmlFor='subscription' className=''>Re-enter Wallet Address *</label>
                          </div>

                          <div className='col-12'>
                            <Field name='addressVerification'>
                              {({
                                field,
                                meta
                              }) => (
                                <>
                                  <div className='fieldWrapper'>
                                    <input
                                      type='text'
                                      className='form-control'
                                      placeholder='' {...field}
                                      aria-required='true'
                                      aria-invalid={!!(meta.touched && meta.error)}
                                      aria-describedby={meta.error}
                                    />
                                  </div>
                                  {meta.touched && meta.error && (
                                    <div className='error'>{meta.error}</div>
                                  )}
                                </>
                              )}
                            </Field>
                          </div>

                          {formProps.isSubmitting && (
                            <div className='statusMessage'>
                              <p>Submitting...</p>
                              <Spinner />
                            </div>
                          )}

                          {!formProps.isSubmitting && !this.showThanks && (
                            <div className='actions'>
                              <button
                                type='submit'
                                className='btn btn-primary edit-button'
                                disabled={Array.isArray(formProps.errors) ||
                                  Object.values(formProps.errors)
                                    .toString() !== '' ||
                                  Object.values(formProps.values)
                                    .filter(str => str.length > 0).length === 0}
                              >
                                Submit
                              </button>
                            </div>
                          )}
                        </div>
                      </Form>
                    )}
                  </Formik>
                )}

                {this.showThanks && (
                  <div className='thanksWrapper'>
                    <div>
                      <p>Your information has been successfully submitted! Thank you.</p>
                    </div>
                  </div>
                )}
              </div>

              <div className='col-lg-6'>
                <h4>
                  <strong>Our Contact Information</strong>
                </h4>
                <hr />
                <div className='row rightSide__contact-info'>
                  <FontAwesomeIcon icon='phone' />{' '}
                  <span> {siteDetails.phone.value}</span>
                </div>
                <div className='row rightSide__contact-info'>
                  <FontAwesomeIcon icon='calendar' />{' '}
                  <span>Mon-Fri, 9am-7pm ET</span>
                </div>
                <div className='row rightSide__contact-info'>
                  <FontAwesomeIcon icon='envelope' />{' '}
                  <span>{siteDetails.mail.services}</span>
                </div>
                <div className='row rightSide__contact-info'>
                  <FontAwesomeIcon icon='map-marker' />
                  <br />{' '}
                  <span>
                    55 NE 5th Ave
                    <br />
                    Delray Beach, FL 33483
                  </span>
                </div>
              </div>
            </div>
          </main>

          <footer className='container'>
            <div className='row'>
              <div className='col-12' />
            </div>
          </footer>

        </div>

        <Modal
          open={this.modalIsOpen}
          onClose={() => { this.modalIsOpen = !this.modalIsOpen }}
          classNames={{
            overlay: 'r-modal-product-overlay',
            modal: 'r-modal-product-modal r-modal-product-bonus',
            closeButton: 'r-modal-product-close'
          }}
          focusTrapped={false}
        >
          <div>
            <div>
              {/* {html2jsx(atob(this.modalContent))} */}

              <div className='modal-body'><h2>How to Claim Your Free NFT</h2>
                <div>
                  <iframe
                    style={{ width: '100%', height: '100%', minHeight: '400px' }}
                    src='https://players.brightcove.net/5102072647001/BJxYHdft0_default/index.html?videoId=6292605548001'
                    allowFullScreen='' allow='encrypted-media'
                  />
                </div>
              </div>

              <p>Dear Reader,</p>
              <p>Welcome to the Brownstone Research and Unchained Profits NFT Giveaway.</p>
              <p>The team is excited to distribute Jeff Brown NFTs to showcase the technology to you, our reader.</p>
              <p>In this guide we will walk you through step by step on how to setup a Phantom wallet. The
                Phantom wallet is a noncustodial wallet for the Solana blockchain. It is similar to the popular
                Ethereum blockchain wallet called MetaMask. MetaMask does not work on Solana, which is
                why we created this specific walkthrough.
              </p>
              <p>Phantom wallet has several features for Solana blockchain users. The feature we are most interested in is the ability to hold and view NFTs. That is why we chose Phantom for this guide. </p>
              <p>If you prefer to use another Solana compatible wallet that can hold and display NFTs that is great. You can skip ahead to Step 10 below to send your wallet address to the Brownstone team for the NFT giveaway.</p>
              <p>Thank you for taking part in this fun and exciting giveaway. We look to reference these NFTs over the coming months and years and we hope you enjoy them as much as we did in making them.</p>

              <h5>Step 1</h5>
              <ul>
                <li>Go to Phantom.app using a Chrome-based browser</li>
              </ul>

              <h5>Step 2</h5>
              <ul>
                <li>Once on the Phantom.app homepage click “Add to Chrome.”</li>
                <li>You will then be directed to the Chrome Web Store.</li>
              </ul>
              <img src='https://scdn.brownstoneresearch.com/BUP/images/202201/AddToChrome.png' className='bonusPopupImage' alt='Step 2' />

              <h5>Step 3</h5>
              <ul>
                <li>Click “Add to Chrome.”</li>
              </ul>
              <img src='https://scdn.brownstoneresearch.com/BUP/images/202201/ChromeStore.png' className='bonusPopupImage' alt='Step 3' />

              <h5>Step 4</h5>
              <ul>
                <li>A pop-up will display the message “It can: read and change all your data on all websites.” This allows the extension to interact and transact with any website you choose to connect it with.</li>
                <li>Go ahead and click “Add extension.”</li>
              </ul>
              <img src='https://scdn.brownstoneresearch.com/BUP/images/202201/AddExtension.png' className='bonusPopupImage' alt='Step 4' />

              <h5>Step 5</h5>
              <ul>
                <li>Click “Create New Wallet”</li>
                <li>For those that already have a Solana-based wallet, go ahead and choose the second option “Use Secret Recovery Phrase” to open your wallet using the Phantom wallet. If you are using a pre-existing wallet for this giveaway, go ahead and skip to step 10.</li>
                <li>For those who are using a hardware wallet to store their NFT, you will still need to create a wallet.</li>
              </ul>
              <img src='https://scdn.brownstoneresearch.com/BUP/images/202201/CreateWallet.png' className='bonusPopupImage' alt='Step 5' />

              <h5>Step 6</h5>
              <ul>
                <li>Store your secret recovery phrase for the new wallet and click “OK, I saved it somewhere.” </li>
                <li>Note: Keep the recovery phrase in a secure location. This is like your username and password to your bank account. If somebody gains access to this recovery phrase, they can transfer the assets held in the wallet. And if you were to lose your secret recovery phrase, you will not be able to gain access to the assets held in the wallet. </li>
              </ul>
              <img src='https://scdn.brownstoneresearch.com/BUP/images/202201/RecoveryPhrase.png' className='bonusPopupImage' alt='Step 6' />

              <h5>Step 7</h5>
              <ul>
                <li>Create a password that will unlock the application on your browser.</li>
                <li>After you agree to the Terms of Service, click “Continue.”</li>
                <li>You will then be shown a keyboard shortcut to open the app, click “Continue” again, and then “Finish.”</li>
              </ul>
              <img src='https://scdn.brownstoneresearch.com/BUP/images/202201/CreatePassword.png' className='bonusPopupImage' alt='Step 7' />

              <h5>Step 8</h5>
              <ul>
                <li>You will now need to copy the wallet’s address. First we need to open the wallet.</li>
                <li>To open the wallet, click on the browser extension ghost icon in the top right of your browser as seen below.</li>
                <li>If the icon is not viewable, click on the jigsaw puzzle next to the ghost icon in the image below, and you will find the wallet extension there.</li>
              </ul>
              <img src='https://scdn.brownstoneresearch.com/BUP/images/202201/WalletExtension.png' className='bonusPopupImage' alt='Step 8' />

              <h5>Step 9</h5>
              <ul>
                <li>When the wallet is displayed, click on the area at the top to copy the wallet’s address to your clipboard.</li>
                <li>For those users that have a hardware wallet, you will need to click the icon in the top left of the wallet. Then choose “Add / Connect Wallet,” click “Connect hardware wallet,” and follow the steps provided.</li>
              </ul>
              <img src='https://scdn.brownstoneresearch.com/BUP/images/202201/AddConnectWallet.png' className='bonusPopupImage' alt='Step 9' />

              <h5>Step 10</h5>
              <ul>
                <li>We now need to submit this address to the Brownstone team to receive the NFT.</li>
              </ul>

              <h5>Step 11</h5>
              <ul>
                <li>Go ahead and input your information.</li>
                <li>In the “Address” field, go ahead and paste your address.</li>
                <li>The website will verify you have entered a correctly formatted public address.</li>
              </ul>

              <h5>Step 12</h5>
              <ul>
                <li>Verify your information is correct and click “Submit.”</li>
                <li><span style={{ color: 'red', fontWeight: 'bold' }}>Important: </span>We recommend you visually confirm that you are entering the correct address. If an incorrect address is submitted, you will not receive your NFT.</li>
                <li>You will now receive an email from Brownstone Research confirming we have received your address for the NFT Giveaway.</li>
              </ul>

              <h5>Step 13</h5>
              <ul>
                <li>Our team will collect reader submissions <b>through February 2nd</b>. Please ensure you have submitted your information before then. </li>
                <li>NFTs will be distributed shortly after that date. And you will be able to view your NFT by clicking on the “four tile” icon at the bottom of your wallet after distribution.</li>
              </ul>
              <img src='https://scdn.brownstoneresearch.com/BUP/images/202201/ViewFourTile.png' className='bonusPopupImage' alt='Step 13' />

            </div>
          </div>
        </Modal>
      </BaseLayout>
    )
  }
}

Bonus.propTypes = {
  store: MobxPropTypes.objectOrObservableObject,
  publication: MobxPropTypes.objectOrObservableObject,
  match: ReactRouterPropTypes.match.isRequired
}

export default withRouter(Bonus)
